module.exports = __webpack_public_path__ + "client/images/404-c5b0235b71a74529eed09aafb8c662a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/client/images/404.jpg
// module id = 1026
// module chunks = 0 16 17